import { trimText } from './stringSanitizer';

const allElementsString = arr => {
  return arr.every(elem => typeof elem === 'string');
};

const allElementsNumbers = arr => {
  return arr.every(elem => typeof elem === 'number');
};

const formatArray = params => {
  if (params.length <= 0) {
    params = [];
  } else if (allElementsString(params) || allElementsNumbers(params)) {
    params = [...params]
      .map(param => (typeof param === 'string' ? trimText(param) : param))
      .filter(param => {
        if (typeof param === 'string') return param.length > 0;
        return param !== null && param !== undefined;
      });
  } else {
    params = params
      .map(val => val.id)
      .filter(param => param !== null && param !== undefined);
  }
  return params;
};

const generatePayloadForObject = item => {
  if (item.action_name === 'send_email_to_team') {
    const payload = item.action_params || {};
    const teamIds = Array.isArray(payload.team_ids)
      ? payload.team_ids
          .map(team =>
            typeof team === 'object' && team !== null ? team.id : team
          )
          .filter(teamId => teamId !== null && teamId !== undefined)
      : [];

    const message = trimText(payload.message || '');
    item.action_params = [
      {
        team_ids: teamIds,
        message,
      },
    ];
    return item.action_params;
  }

  if (item.action_params.id) {
    item.action_params = [item.action_params.id];
  } else {
    const value =
      typeof item.action_params === 'string'
        ? trimText(item.action_params)
        : item.action_params;
    item.action_params = value ? [value] : [];
  }
  return item.action_params;
};

const generatePayload = data => {
  const actions = JSON.parse(JSON.stringify(data));
  let payload = actions.map(item => {
    if (Array.isArray(item.action_params)) {
      item.action_params = formatArray(item.action_params);
    } else if (typeof item.action_params === 'object') {
      item.action_params = generatePayloadForObject(item);
    } else if (!item.action_params) {
      item.action_params = [];
    } else {
      const value =
        typeof item.action_params === 'string'
          ? trimText(item.action_params)
          : item.action_params;
      item.action_params = value ? [value] : [];
    }
    return item;
  });
  return payload;
};

export default generatePayload;
